import { provideAiTabDestinationRunners } from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-tab-destinations";

/**
 * Gives the tabs that declared themselves a router to go through.
 *
 * A run block because it has to outlive every page: the point of a tab declaring itself is that the
 * AI can be sent there from anywhere, which a runner living on the tab could never do. See
 * `ai-tab-destinations.ts` for what a tab declares.
 */
//! @ngInject
export function aiTabDestinations($state, $timeout) {
    // No `reload`, and through $timeout, for the same reason app.navigate does it: the omnibar
    // panel reporting this step sits in the navbar that a reload would re-link.
    provideAiTabDestinationRunners((stateName) => $timeout(() => $state.go(stateName)));
}
